module.exports = "/assets/data/d36faf181bf73ece7f077ac235a78966-CF24.data.json";